import { gql } from 'graphql-tag';

export const CART_FIELDS = gql`
  fragment CartFields on Cart {
    contents(first: 100) {
      itemCount
      nodes {
        key
        product {
          node {
            id
            databaseId
            name
            ... on SimpleProduct {
              price
            }
          }
        }
        quantity
        total
        subtotal
      }
    }
    total
    subtotal
    totalTax
    feeTotal
    shippingTotal
  }
`;

export const QUERY_CART = gql`
  query GetCart {
    cart {
      ...CartFields
    }
  }
  ${CART_FIELDS}
`;

export const MUTATION_ADD_TO_CART = gql`
  mutation AddToCart($input: AddToCartInput!) {
    addToCart(input: $input) {
      cart {
        ...CartFields
      }
    }
  }
  ${CART_FIELDS}
`;

export const MUTATION_REMOVE_ITEM = gql`
  mutation RemoveItemFromCart($input: RemoveItemsFromCartInput!) {
    removeItemsFromCart(input: $input) {
      cart {
        ...CartFields
      }
    }
  }
  ${CART_FIELDS}
`;

export const MUTATION_UPDATE_QUANTITY = gql`
  mutation UpdateItemQuantities($input: UpdateItemQuantitiesInput!) {
    updateItemQuantities(input: $input) {
      cart {
        ...CartFields
      }
    }
  }
  ${CART_FIELDS}
`;

export const MUTATION_CHECKOUT = gql`
  mutation Checkout($input: CheckoutInput!) {
    checkout(input: $input) {
      order {
        databaseId
        orderKey
        orderNumber
        status
      }
      result
      redirect
    }
  }
`;
